import { Col, Divider, Form, Input, notification, Row, Select } from "antd";
import "../../../styles/candidateOnboarding.css";
import React, { useEffect, useState } from "react";
import Loader from "../../../components/Loader";
import Utils from "../../../utils/Utils";
import Icon from "../../../assets/Icon";
import ProgressBar from "./ProgressBar";
import WebUtils from "../../../utils/WebUtils";
import { createCandidateCatalystInfoApi } from "../../../api/candidate";
import { getOnBoardingStatusApi } from "../../../api/common";

const userDetail = Utils.getUserDetail();
const userRole = "JOBDRONA_CANDIDATE";

function CandidateOnboarding() {
  const [loading, setLoading] = useState(false);

  const getOnboardStatus = async () => {
    const url = `${getOnBoardingStatusApi}?userIdentifier=${
      userDetail?.userIdentifier || null
    }&userRole=${userDetail?.userRole}`;

    setLoading(true);

    WebUtils.httpOperations(url, {}, "GET")
      .then((result) => {
        setLoading(false);
        if (result.data.data === "ONBOARDING_REQUIRED") {
          return;
        } else if (result.data.data === "COMPLETED") {
          window.location.href = "/dashboard";
        }
      })
      .catch((err) => {
        setLoading(false);
        console.log(err);
      });
  };

  useEffect(() => {
    getOnboardStatus();
  }, []);

  const handleSubmit = async (values) => {
    const postUrl = `${createCandidateCatalystInfoApi}?userIdentifier=${
      userDetail?.userIdentifier || null
    }&userRole=${userRole}`;

    const reqBody = {
      collegeName: values.collegeName,
      yearsOfExperience: Number(values.yearsOfExperience),
      yearOfBirth: Number(values.yearofBirth),
      organizationId: values.activationCode,
    };
    setLoading(true);

    WebUtils.httpOperations(postUrl, reqBody, "POST")
      .then((result) => {
        setLoading(false);
        if (
          result.data.resultStatusInfo.resultCode.toLowerCase() === "success"
        ) {
          notification.success({
            message: "Registration successful!",
            description: `Candidate details created! Redirecting to the dashboard!`,
            placement: "top",
            showProgress: true,
          });
          setTimeout(() => {
            window.location.href = "/dashboard";
          }, 4000);
        } else {
          notification.error({
            message: "Registration unsuccessful!",
            placement: "top",
          });
        }
      })
      .catch((err) => {
        setLoading(false);
        console.log(err);
      });
  };

  return (
    <>
      {loading && <Loader />}
      <nav className="w-full m-auto py-[.9rem] px-4 lg:px-12 onboardingProgress bg-[#0F1B23] flex gap-[.1rem] items-center">
        {/* <Icon type="hire-logo" width={86} height={46} /> */}
        <Icon type="jobdrona-logo" width={45} height={28} />
        <span className="font-bold text-orangish text-[1.2rem]">JobDrona</span>
      </nav>
      <div className="text-[#101828] font-semibold w-[86%] md:w-[93%] text-[1.4rem] mt-10 md:mt-8 lg:mt-4 text-left md:text-center mx-auto">
        Complete your profile
      </div>
      <ProgressBar currentStep={2} />
      <div className="w-[86%] lg:w-[78%] xl:w-[72%] m-auto pt-[0.8rem] lg:pt-[2rem] pb-[2.2rem] candidate-onboarding-container">
        <div>
          <p className="text-[#101828] font-semibold text-[1.4rem]">
            Candidate details
          </p>
          <p className="text-[#475467] w-[80%] text-[0.95rem]">
            Provide your personal and professional details
          </p>
        </div>
        <Divider />
        <Form onFinish={handleSubmit}>
          <Row className="mt-6 gap-y-2">
            <Col className="w-full lg:w-[33%]">
              <div className="text-[#101828] font-semibold text-[0.95rem]">
                College / University Name <span className="text-[#206DC5]">*</span>
              </div>
            </Col>
            <Col className="space-y-3 w-full lg:w-[50%]">
              <Form.Item
                name="collegeName"
                className=" p-0 m-0"
                rules={[
                  {
                    required: true,
                    message: "Please enter your college name!",
                  },
                ]}
              >
                <Input className="w-full" placeholder="College / University Name" />
              </Form.Item>
            </Col>
          </Row>
          <Row className="mt-5 gap-y-2">
            <Col className="w-full lg:w-[33%]">
              <div className="text-[#101828] font-semibold text-[0.95rem]">
                Years of Experience <span className="text-[#206DC5]">*</span>
              </div>
            </Col>
            <Col className="space-y-3 w-full lg:w-[50%]">
              <Form.Item
                name="yearsOfExperience"
                className="p-0 m-0"
                rules={[
                  {
                    required: true,
                    message: "Please enter your years of experience!",
                  },
                ]}
              >
                <Input
                  className="w-full"
                  type="number"
                  placeholder="Years of Experience"
                />
              </Form.Item>
            </Col>
          </Row>
          <Row className="mt-5 gap-y-2">
            <Col className="w-full lg:w-[33%]">
              <div className="text-[#101828] font-semibold text-[0.95rem]">
                Year of Birth <span className="text-[#206DC5]">*</span>
              </div>
            </Col>
            <Col className="space-y-3 w-full lg:w-[50%]">
              <Form.Item
                name="yearofBirth"
                className="p-0 m-0"
                rules={[
                  {
                    required: true,
                    message: "Please enter your year of birth!",
                  },
                ]}
              >
                <Input className="w-full" type="number" placeholder="YYYY" />
              </Form.Item>
            </Col>
          </Row>
          <Row className="mt-5 gap-y-2">
            <Col className="w-full lg:w-[33%]">
              <div className="text-[#101828] font-semibold text-[0.95rem]">
                Organization Activation Code
                <span className="text-[#206DC5]">*</span>
              </div>
            </Col>
            <Col className="space-y-3 w-full lg:w-[50%]">
              <Form.Item
                name="activationCode"
                className="p-0 m-0"
                rules={[
                  {
                    required: true,
                    message: "Please enter your activation code!",
                  },
                ]}
              >
                <Input className="w-full" placeholder="Activation code..." />
              </Form.Item>
              <span className="text-sm font-semibold">
                (Please Enter Activation Code provided by your Organization . If
                you don't have one and just trying it yourself , please use
                <strong className="text-[#206DC5] ">
                  {"  "}I LOVE JOB DRONA
                </strong>
                {"  "}
                as activation code)
              </span>
            </Col>
          </Row>

          <Divider />

          <Row className="mt-5 gap-y-2">
            <Col className="w-full flex flex-col-reverse md:flex-row justify-end gap-2">
              <button
                className="text-[0.9rem] w-full md:w-auto btn-orange py-[7px] px-8"
                type="submit"
              >
                Activate
              </button>
            </Col>
          </Row>
        </Form>
      </div>
    </>
  );
}

export default CandidateOnboarding;
